import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import i18n from "@/i18n";
import router from '@/plugins/router';

Sentry.init({
    Vue,
    dsn: window.SENTRY_DSN,
    environment: window.SENTRY_ENVIRONMENT,
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "bauplan.hw.ag", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5

    // beforeSend(event, hint) {
    //     // Check if it is an exception, and if so, show the report dialog
    //
    //     if (event.exception) {
    //
    //         console.log(event);
    //
    //         // disable blocked matomo script reporting
    //         if (event.extra
    //             && event.extra.__serialized__
    //             && event.extra.__serialized__.target
    //             && event.extra.__serialized__.target.indexOf('script') !== -1) {
    //             return;
    //         }
    //
    //         Sentry.showReportDialog({
    //             eventId: event.event_id,
    //             user: Vue.auth.user(),
    //             lang: i18n.locale
    //         });
    //     }
    //     return event;
    // }
});
